export default __webpack_public_path__ + "static/media/logo_ayam_koplo.0be695bf.png";